// extracted by mini-css-extract-plugin
module.exports = {"Title":"style-module--Title--E5vzK","Subtitle":"style-module--Subtitle--JcyLL"};